export const environment = {
  production: false,
  version: '6.0.0',
  mockData: false,
  apiUrl: 'https://amlapi-dev.starexchangealliance.com',
  hasDarkTheme: false,
  devMode: true,
  linkWebVersion: 'https://aml-dev.starexchangealliance.com'
};
